import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router';
import { PageProvider } from './context/PageContext';
import './assets/global.css';

const tgHash = window.location.hash;
window.__TG_HASH__ = tgHash; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<BrowserRouter>
		<PageProvider>
			<App />
		</PageProvider>
	</BrowserRouter>
);
